<template>
  <div id="public-view">
    <header id="header" class="">
      <div class="header-middle">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <div id="nav-mobile-menu-control" v-on:click="activeMenu = !activeMenu"
                v-bind:class="{ 'active': activeMenu }">
                <i class="show-menu fal fa-bars"></i>
                <i class="hide-menu fal fa-cog"></i>
              </div>
              <div itemscope itemtype="https://schema.org/Organization" id="page-logo">
                <router-link to="/"><img itemprop="logo" src="/image/catalog/header-logo.png"
                    alt="Logo Hafele" /></router-link>
              </div>
              <div id="header-search-box">
                <input type="text" placeholder="Tìm kiếm ở đây" v-model="searchQuery" @keyup.enter="search">
                <button v-on:click="search">
                  <i class="fal fa-search"></i>
                </button>
              </div>
              <div id="hotline" class="d-none d-lg-flex">
                <div class="icon">
                  <a :href="'tel:' + hotlineTrim">
                    <i class="fas fa-phone"></i></a>
                </div>
                <div class="text-wrap ">
                  <span class="text">
                    Bạn cần giúp đỡ?
                  </span>
                  <a :href="'tel:' + hotlineTrim">{{ hotline }}</a>
                </div>
              </div>
              <div id="shopping-cart-control">
                <router-link to="/cart">
                  <div v-if="cartQuantity" class="num">{{ cartQuantity }}</div>
                  <i class="fal fa-shopping-cart"></i>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="header_bottom">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <div id="pc-menu-wrap">
                <div id="pc-menu-control" v-bind:class="{ 'active': activeMenu }" v-on:click="activeMenu = !activeMenu">

                  <i class="show-menu fal fa-bars"></i>
                  <i class="hide-menu fal fa-cog"></i> <span>Danh mục sản phẩm</span>
                </div>
                <div id="pc-sub-menu">
                  <div class="menu-item menu-logo">
                    <router-link to="/"><img itemprop="logo" src="/image/catalog/header-logo2.png"
                        alt="Logo Hafele" /></router-link>
                  </div>
                  <div class="menu-item">
                    <router-link to="/">Sản phẩm hot</router-link>
                  </div>

                  <div class="menu-item menu-logo">
                    <a :href="'tel:' + hotlineTrim"><i class="fas fa-phone"></i></a>
                    <a :href="'tel:' + hotlineTrim">
                      <span v-for="(c, i) in hotlineTrim" :key="i" :class="'t' + (i + 1)">{{ ((i == 4 || i == 7) ?'&nbsp;' : '') + c }}</span>
                    </a>
                  </div>
                  <div class="menu-item item-full">
                  </div>
                  <div class="menu-item menu-logo">
                    <router-link to="/cart">
                      <button class="btn btn-add-to-cart">
                        <div v-if="cartQuantity" class="num">{{ cartQuantity }}</div>
                        <i class="fal fa-cart-plus"></i>
                      </button>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="header-mobile-search">
        <div id="header-mobile-search-box"><input type="text" v-model="searchQuery" placeholder="Tìm kiếm ở đây"
            @keyup.enter="search"><button v-on:click="search"><i class="fal fa-search"></i></button>
        </div>
      </div>
    </header>


    <div id="mobile-menu" v-bind:class="{ 'active': activeMenu }">

      <ul id="categories-mobile-menu-left">
        <li v-for="lv1 in navMenu" :key="lv1._id" class="menu-lv-1" data-id="cmm-0" v-on:click="selectMenu = lv1"
          v-bind:class="{ 'active': lv1 == selectMenu }">
          <div class="text-lv-1 active">
            <span class="image">
              <img :src="resizeImage(lv1.avatar, 30, 30)">
            </span>
            <span class="name">
              <span>{{ lv1.name }}</span>
            </span>
          </div>
        </li>
      </ul>



      <div id="categories-mobile-menu-right" v-on:click="activeMenu = false">
        <div id="categories-mobile-menu-right-x">
          <div class="menu-lv-1" v-for="lv1 in navMenu" :key="lv1._id" v-bind:class="{ 'active': lv1 == selectMenu }">
            <div class="menu-lv-2-wrap-x">
              <h3><router-link :to="cateLink(lv1)">{{ lv1.name }}</router-link></h3>
              <ul class="menu-lv-2-wrap">
                <li class="menu-lv-2" v-for="lv2 in lv1.child" :key="lv2._id">
                  <router-link :to="cateLink(lv2)" class="image">
                    <img :src="resizeImage(lv2.avatar, 120, 120)">
                  </router-link>
                  <router-link :to="cateLink(lv2)" class="">
                    {{ lv2.name }}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
    <slot></slot>
    <PageFooter v-if="homeModules && homeModules.length > 0" :data="homeModules[0].data" />
  </div>
</template>
<script>
//import HeaderTop from "@/components/Shared/HeaderTop.vue";
  //import NavMenu from "@/components/Shared/NavMenu.vue";
  import PageFooter from "@/components/Shared/PageFooter.vue";
let scrollHandle = null;
export default {
  data() {
    return {
      activeMenu: false,
      selectMenu: null,
      searchQuery: ""
    }
  },
  mounted() {
    const header = document.querySelector('#header');
    setTimeout(() => {
      scrollHandle = window.addEventListener("scroll", function () {
        if (window.scrollY > 200) {
          header.classList.add('scroll-header');
        } else {
          header.classList.remove('scroll-header');
        }
      })

      if (Array.isArray(this.navMenu) && this.navMenu.length > 0) {
        this.selectMenu = this.navMenu[0];
      } else {
        this.selectMenu = null;
      }
    }, 100);
  },
  methods: {
        resizeImage(link, width, height) {
            const test = /^\/images\/(.+)\.(jpg|png|webp)$/.exec(link);
            if(test) {
                // Đổi link ban đầu thành link đã được resize (ví dụ sử dụng một service resize)
                return "/images-thumb/" + test[1] + "." + test[2] + "." + width + "." + height + "." + test[2];
            } else {
                return link;
            }
        },
    search() {
      if(this.searchQuery.trim().length > 0) {
        this.$router.push({ path: "/search", query: { q: this.searchQuery.trim() } });
      }

    },
    removeVietnameseTones(str) {
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
      str = str.replace(/đ/g, "d");
      str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
      str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
      str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
      str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
      str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
      str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
      str = str.replace(/Đ/g, "D");
      // Some system encode vietnamese combining accent as individual utf-8 characters
      // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
      str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
      str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
      // Remove extra spaces
      // Bỏ các khoảng trắng liền nhau
      str = str.replace(/ + /g, " ");
      str = str.trim();
      // Remove punctuations
      // Bỏ dấu câu, kí tự đặc biệt
      str = str.replace(/!|@|%|\^|\*|\(|\)|\+|=|<|>|\?|\/|,|\.|:|;|'|"|&|#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
      return str;
    },
    cateLink(cateObj) {
      return "/danh-muc/" + this.removeVietnameseTones(cateObj.name).replaceAll(" ", "-").toLowerCase() + "/" + cateObj._id;
    }
  },
    computed: {
      hotlineTrim() {
        return this.hotline.replaceAll(" ", "");
      },
      hotline() {
        if (this.homeModules && this.homeModules.length > 0) {
          let tel = this.homeModules[0].data.contact.find(item => item.type === "tel");
          if(tel) {
            return tel.value;
          }
        }
        return "0915 761 838";
      },
      homeModules() {
        return this.$store.getters.homeModules;
      },
    cartQuantity() {
      return this.cart ? this.cart.reduce((total, item) => total + item.quantity, 0) : 0;
    },
    cart() {
      return this.$store.getters.cart;
    },
    navMenu() {
      return this.$store.getters.navData;
    }
  },
  beforeUnmount() {
    window.removeEventListener("scroll", scrollHandle);
  },
    components: { PageFooter },
  watch: {
    navMenu(val) {
      if (Array.isArray(val) && val.length > 0) {
        this.selectMenu = val[0];
      } else {
        this.selectMenu = null;
      }
    }
  }
};
</script>
<style lang="less">
:root {
  --border-color: #dfe0e1;
}

@keyframes shake {
  0% {
    transform: scale(1) rotateZ(0);
  }

  5% {
    transform: scale(1.1) rotateZ(0);
    color: black;
  }

  7.5% {
    transform: scale(1.1) rotateZ(-10deg);
    color: #ad052d;
  }

  10% {
    transform: scale(1.1) rotateZ(10deg);
  }

  12.5% {
    transform: scale(1.1) rotateZ(-10deg);
  }

  15% {
    transform: scale(1.1) rotateZ(10deg);
  }

  17.5% {
    transform: scale(1.1) rotateZ(-10deg);
  }

  20% {
    transform: scale(1.1) rotateZ(10deg);
  }

  22.5% {
    transform: scale(1.1) rotateZ(-10deg);
  }

  25% {
    transform: scale(1.1) rotateZ(10deg);
  }

  27.5% {
    transform: scale(1.1) rotateZ(-10deg);
  }

  30% {
    transform: scale(1.1) rotateZ(10deg);
  }

  32.5% {
    transform: scale(1.1) rotateZ(-10deg);
  }

  35% {
    transform: scale(1) rotateZ(10deg);
    color: #ad052d;
  }

  40% {
    transform: rotateZ(0);
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}


@keyframes at1 {
  0% {
    transform: scale(1);
  }

  40% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  44% {
    transform: scale(2);
    font-weight: bold;
    color: #ad052d;
  }

  48% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes at2 {
  0% {
    transform: scale(1);
  }

  42% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  46% {
    transform: scale(2);
    font-weight: bold;
    color: #ad052d;
  }

  50% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes at3 {
  0% {
    transform: scale(1);
  }

  44% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  48% {
    transform: scale(2);
    font-weight: bold;
    color: #ad052d;
  }

  52% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes at4 {
  0% {
    transform: scale(1);
  }

  46% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  50% {
    transform: scale(2);
    font-weight: bold;
    color: #ad052d;
  }

  54% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes at5 {
  0% {
    transform: scale(1);
  }

  48% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  52% {
    transform: scale(2);
    font-weight: bold;
    color: #ad052d;
  }

  56% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes at6 {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  54% {
    transform: scale(2);
    font-weight: bold;
    color: #ad052d;
  }

  58% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes at7 {
  0% {
    transform: scale(1);
  }

  52% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  56% {
    transform: scale(2);
    font-weight: bold;
    color: #ad052d;
  }

  60% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes at8 {
  0% {
    transform: scale(1);
  }

  54% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  58% {
    transform: scale(2);
    font-weight: bold;
    color: #ad052d;
  }

  62% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes at9 {
  0% {
    transform: scale(1);
  }

  56% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  60% {
    transform: scale(2);
    font-weight: bold;
    color: #ad052d;
  }

  64% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes at10 {
  0% {
    transform: scale(1);
  }

  58% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  62% {
    transform: scale(2);
    font-weight: bold;
    color: #ad052d;
  }

  66% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

#public-view {
  padding-top: 130px;

  .container-fluid {
    max-width: 1700px;
  }

  

  #header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10000;

    .header-middle {
      display: flex;
      background-color: #ad052d;
      max-height: 150px;
      overflow: hidden;
      transition: max-height .5s, padding .5s;

      .col-12 {
        display: flex;
        padding: 0;
      }

      #nav-mobile-menu-control,
      #shopping-cart-control {
        width: 62px;
        height: 62px;
        line-height: 62px;
        text-align: center;
        color: white;
        font-size: 20px;
        position: relative;

        a {
          color: inherit;
        }

        .num {
          position: absolute;
          top: 14px;
          right: 8px;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background-color: white;
          color: black;
          font-size: 12px;
          line-height: 16px;
          text-align: center;
        }

        .show-menu,
        .hide-menu {
          position: absolute;
          top: 0;
          left: 0;
          width: 62px;
          height: 62px;
          line-height: 62px;
          text-align: center;
        }

        .show-menu {
          opacity: 1;
        }

        .hide-menu {
          opacity: 0;
        }
      }

      #nav-mobile-menu-control {
        .show-menu {
          transition: transform 1s, opacity 0.2s 0.6s;
        }

        .hide-menu {
          transition: transform 1s, opacity .4s .6s;
          font-size: 40px;
        }

        &.active {
          .show-menu {
            opacity: 0;
            transform: rotateZ(-420deg);
            transition: 1s transform, 0.2s opacity;
          }

          .hide-menu {
            opacity: 1;
            transform: rotateZ(-420deg);
            transition: 1s transform, 0.2s opacity;
          }

        }
      }

      #page-logo {
        line-height: 62px;
        flex: 1;
        text-align: left;

        img {
          height: 25px;
        }
      }

      #hotline {
        display: none;
      }

      #header-search-box {
        display: none;
      }

    }

    .header_bottom {
      height: 55px;
      width: 100%;
      border-top: 1px solid var(--border-color);
      border-bottom: 1px solid var(--border-color);
      display: none;

      #pc-menu-wrap {
        display: flex;
        width: 100%;
        padding: 15px 0;

        #pc-menu-control {
          width: 230px;
          margin-right: 20px;
          font-size: 15px;
          border-right: 1px solid #dfe0e1;
          padding-right: 25px;
          cursor: pointer;
          position: relative;
          padding-left: 50px;

          .icon {
            margin-right: 20px;
            font-size: 19px;
          }

          &.active {
            color: #ad052d;

            span {
              font-weight: bold;
            }
          }
        }

        #pc-menu-control {

          .show-menu,
          .hide-menu {
            position: absolute;
            top: -19px;
            left: 0;
            width: 62px;
            height: 62px;
            line-height: 62px;
            text-align: center;
          }

          .show-menu {
            opacity: 1;
          }

          .hide-menu {
            opacity: 0;
          }
        }

        #pc-menu-control {
          .show-menu {
            transition: transform 1s, opacity 0.2s 0.6s;
          }

          .hide-menu {
            transition: transform 1s, opacity .4s .6s;
            font-size: 40px;
          }

          &.active {
            .show-menu {
              opacity: 0;
              transform: rotateZ(-420deg);
              transition: 1s transform, 0.2s opacity;
            }

            .hide-menu {
              opacity: 1;
              transform: rotateZ(-420deg);
              transition: 1s transform, 0.2s opacity;
            }

          }
        }

        #pc-sub-menu {
          flex: 1;
          display: flex;
          flex-direction: row;

          a {
            color: inherit;
            text-decoration: none;
          }

          .menu-item {
            padding: 0 15px;
            height: 25px;
            overflow: hidden;

            a.active {
              color: #ad052d;

            }

            &.item-full {
              flex: 1;
              display: flex;
              justify-content: flex-end;
            }

            .btn.btn-add-to-cart {
              height: 25px;
              padding-top: 0;
              padding-bottom: 0;
              position: relative;

              a {
                color: inherit;
              }

              .num {
                position: absolute;
                top: 0;
                right: 0;
                background-color: #ad052d;
                color: white;
                width: 16px;
                height: 16px;
                font-size: 12px;
                line-height: 16px;
                text-align: center;
                border-radius: 50%;
              }
            }

            &.menu-logo {
              transition: max-width .5s, padding .5s;
              max-width: 0;
              padding: 0;
              overflow: hidden;
              word-break: keep-all;

              img {
                height: 24px;
              }

              .fa-phone {
                animation: shake 4s infinite;
              }

              span {
                display: inline-block;
              }

              span.t1 {
                animation: at1 4s infinite;

              }

              span.t2 {
                animation: at2 4s infinite;
              }

              span.t3 {
                animation: at3 4s infinite;
              }

              span.t4 {
                animation: at4 4s infinite;
              }

              span.t5 {
                animation: at5 4s infinite;
              }

              span.t6 {
                animation: at6 4s infinite;
              }

              span.t7 {
                animation: at7 4s infinite;
              }

              span.t8 {
                animation: at8 4s infinite;
              }

              span.t9 {
                animation: at9 4s infinite;
              }

              span.t10 {
                animation: at10 4s infinite;
              }
            }
          }
        }

      }

    }

    .header-mobile-search {
      padding-top: 15px;
      background-color: white;
      padding-bottom: 15px;
      max-height: 100px;
      transition: max-height 0.5s, padding-top 0.5s, padding-bottom 0.5s;

      #header-mobile-search-box {
        flex: 1;
        display: flex;
        justify-content: center;
        padding-left: 15px;
        padding-right: 15px;

        input {
          flex: 1;
          max-width: 600px;
          height: 41px;
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
          padding-left: 20px;
          border: none;
          outline: none;
          background-color: #f5f5f5;
        }

        button {
          width: 50px;
          height: 41px;
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
          border: none;
          background-color: #f5f5f5;
        }
      }
    }

    &.scroll-header {
      .header-mobile-search {
        max-height: 0;
        overflow: hidden;
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  }

  #mobile-menu {
    position: fixed;
    z-index: 10000;
    top: 48px;
    bottom: 0;
    width: 100%;
    max-width: 395px;
    left: -450px;
    background: url("../assets/images/gear_2.png") top left repeat-x;
    transition: left 1s, top 1s;
    background-position-x: 11.5px;
    padding-top: 10px;
    display: flex;

    &.active {
      left: 0;
    }

    #mobile-menu-x {
      background-color: #dfe0e1;
      display: flex;
      width: 100%;
      height: 100%;
      padding-top: 10px;
    }

    #categories-mobile-menu-left {
      padding: 20px 0 0 0;
      width: 80px;
      height: 100%;
      overflow-y: auto;
      background-color: white;

      &::-webkit-scrollbar {
        width: 4px;
        /* Điều chỉnh độ rộng, có thể thay đổi theo nhu cầu */
      }

      &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.2);
        /* Màu của thanh cuộn */
        border-radius: 4px;
        /* Bo góc cho thanh cuộn */
      }

      .menu-lv-1 {
        .image {
          text-align: center;
          display: block;

          img {
            max-width: 40px;
            max-height: 40px;
          }
        }

        .name {
          font-size: 14px;
          text-align: center;
          display: block;
        }

        &.active {
          .name {
            font-weight: bold;
            color: #ad052d;
          }
        }
      }
    }

    #categories-mobile-menu-right {
      width: calc(100% - 80px);

      #categories-mobile-menu-right-x {
        background-color: #dfe0e1;
        height: 100%;
        width: 100%;
        padding: 20px 0;
        position: relative;

      }

      .menu-lv-1 {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        display: none;
        padding-top: 30px;

        &.active {
          display: block;
        }

        .menu-lv-2-wrap-x {
          list-style: none;
          display: flex;
          height: 100%;
          flex-direction: column;


          h3 {
            width: 100%;

            a {
              color: inherit;
              text-decoration: none;
            }
          }

          .menu-lv-2-wrap {
            list-style: none;
            width: 100%;
            padding: 0;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            overflow-y: auto;
            flex-direction: row;

            &::-webkit-scrollbar {
              width: 4px;
              /* Điều chỉnh độ rộng, có thể thay đổi theo nhu cầu */
            }

            &::-webkit-scrollbar-thumb {
              background-color: rgba(0, 0, 0, 0.2);
              /* Màu của thanh cuộn */
              border-radius: 4px;
              /* Bo góc cho thanh cuộn */
            }

            .menu-lv-2 {
              width: 120px;
              margin: 15px;
              max-width: calc(50% - 30px);
              padding: 10px 0;
              border-radius: 5px;
              background-color: white;

              >a {
                display: flex;
                width: 100%;
                text-align: center;
                justify-content: center;
                color: inherit;
                text-decoration: none;
                font-size: 14px;

                img {
                  max-width: 100%;
                }

                &:nth-of-type(2) {
                  padding: 5px 5px 0 5px;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (min-width: 992px) {
  #public-view {
    padding-top: 153px;

    #header {
      .header-middle {
        padding: 24px 0;

        .col-12 {
          padding: 0 15px;
        }

        #nav-mobile-menu-control {
          display: none;
        }

        #shopping-cart-control {
          height: 43px;
          line-height: 43px;
          margin-right: 20px;

          .num {
            top: 5px;
          }

        }

        #hotline {
          height: 43px;
          line-height: 43px;
          color: white;
          text-align: center;
          display: flex;

          a {
            color: inherit;
          }

          .icon {
            width: 43px;
            font-size: 30px;
          }

          .text-wrap {
            line-height: 22px;
            text-align: left;
            padding-left: 10px;
            padding-right: 10px;

            .text {
              width: 100%;
              display: block;
              font-size: 13px;
            }

            a {
              color: inherit;
              text-decoration: none;
              font-size: 16px;
            }
          }
        }

        #page-logo {
          height: 43px;
          line-height: 43px;
          flex: none;
        }

        #header-search-box {
          flex: 1;
          display: flex;
          justify-content: center;
          padding-left: 30px;
          padding-right: 30px;

          input {
            flex: 1;
            max-width: 600px;
            height: 41px;
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            padding-left: 20px;
            border: none;
            outline: none;
          }

          button {
            width: 50px;
            height: 41px;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
            border: none;
            background-color: white;
          }
        }

      }

      .header_bottom {
        display: flex;
        background-color: white;
      }

      .header-mobile-search {
        display: none;
      }

      &.scroll-header {
        .header-middle {
          max-height: 0;
          padding: 0;
        }

        .header_bottom {
          #pc-menu-wrap {
            #pc-sub-menu {

              .menu-item {
                &.menu-logo {
                  max-width: 180px;
                  padding: 0 15px;
                }
              }
            }

          }
        }
      }
    }

    #header.scroll-header+#mobile-menu {
      top: 47px;
    }

    #mobile-menu {
      top: 137px;
      left: -100vw;
      bottom: 0;
      width: 100vw;
      max-width: 100vw;
      background: url("../assets/images/gear_2.png") top left repeat-x;
      background-position-x: 4.5px;

      ul {
        margin-bottom: 0;
      }

      &.active {
        left: 0;
      }

      #categories-mobile-menu-left {
        width: 225px;

        .menu-lv-1 {
          .text-lv-1 {
            display: flex;

            .image {
              width: 40px;
              display: inline-block;
              height: 40px;
              border-radius: 50%;
              overflow: hidden;
              padding: 5px;

              img {
                width: 30px;
                height: 30px;
                border-radius: 50%;
                overflow: hidden;
                cursor: pointer;
              }
            }

            .name {
              flex: 1;
              padding-left: 10px;
              line-height: 30px;
              text-align: left;
              cursor: pointer;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              padding-right: 10px;
            }
          }

        }
      }

      #categories-mobile-menu-right {
        width: calc(100% - 225px);
      }
    }
  }
}


@media (min-width: 1700px) {
  #public-view {
    #header {
      .header-middle {
        padding: 24px 0;

        .col-12 {
          padding: 0 15px;
        }

        #nav-mobile-menu-control {
          display: none;
        }

        #shopping-cart-control {
          height: 43px;
          line-height: 43px;
          margin-right: 20px;

        }

        #hotline {
          height: 43px;
          line-height: 43px;
          color: white;
          text-align: center;
          display: flex;

          a {
            color: inherit;
          }

          .icon {
            width: 43px;
            font-size: 30px;
          }

          .text-wrap {
            line-height: 22px;
            text-align: left;
            padding-left: 10px;
            padding-right: 10px;

            .text {
              width: 100%;
              display: block;
              font-size: 13px;
            }

            a {
              color: inherit;
              text-decoration: none;
              font-size: 16px;
            }
          }
        }

        #page-logo {
          height: 43px;
          line-height: 43px;
          flex: none;
        }

        #header-search-box {
          flex: 1;
          display: flex;
          justify-content: center;
          padding-left: 30px;
          padding-right: 30px;

          input {
            flex: 1;
            max-width: 600px;
            height: 41px;
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            padding-left: 20px;
            border: none;
            outline: none;
          }

          button {
            width: 50px;
            height: 41px;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
            border: none;
            background-color: white;
          }
        }

      }

      .header_bottom {
        display: flex;
      }
    }

    #mobile-menu {
      padding-left: calc(50vw - 850px);
      width: calc(50vw + 850px);
      background: none;

      &.active {
        left: 0;
      }

      &::before {
        content: " ";
        position: absolute;
        top: 0;
        right: 0;
        left: calc(50vw - 850px);
        ;
        background: url("../assets/images/gear_2.png") top left repeat-x;
        background-position-x: 15.5px;
        height: 11px;
      }

      &::after {
        content: " ";
        position: absolute;
        background-color: #dfe0e1;
        top: 10px;
        left: 0;
        bottom: 0;
        width: calc(50vw - 850px);

      }

      #categories-mobile-menu-left {}

      #categories-mobile-menu-right {}
    }
  }

}
</style>